import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import {
    RaikoCustomSelect,
    RaikoSimpleInputOutlined,
    raikoCustomSelectItemGenerator,
    RaikoToggleOutlined,
    RaikoSectionContainer,
    showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {LanguageService} from "../../../serverService/languageService/LanguageService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function AddNewLanguage({selectedLanguage, changeNeedRefresh,handleCloseDialog}) {


    const service = new LanguageService();

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [name, setName] = useState("");
    const [locale, setLocale] = useState("");
    const [direction, setDirection] = useState("RTL");
    const [calendarType, setCalendarType] = useState("JALALI");
    const [enabled, setEnabled] = useState(true);
    const [isDefault, setIsDefault] = useState(false);
    useEffect(() => {
        if (selectedLanguage && selectedLanguage >= 0) {
            getLanguageInfoFromServer()
        }
    }, [selectedLanguage])

    function getLanguageInfoFromServer() {
        loading.show()
        service.getLanguageInfo(selectedLanguage)
            .then(response => {

                setName(response.name)
                setLocale(response.code)
                setDirection(response.direction)
                setCalendarType(response.calendarType)
                setEnabled(response.enabled)
                setIsDefault(response.isDefault)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function doAction() {
        if (selectedLanguage >= 0) {
            doUpdateLanguage()
        } else {
            doAddNewLanguage()
        }
    }

    function doUpdateLanguage() {
        loading.show()
        service.updateLanguage(
            selectedLanguage,
            name,
            locale,
            direction,
            calendarType,
            enabled,
            isDefault
        ).then(response => {
            changeNeedRefresh(true)
            showSuccessMessage("زبان با موفقیت بروزرسانی شد!")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_=>{
            loading.hide()
            handleCloseDialog()
        })
    }

    function doAddNewLanguage() {
        loading.show()
        service.addNewLanguage(
            name,
            locale,
            direction,
            calendarType,
            enabled,
            isDefault
        ).then(response => {
            changeNeedRefresh(true)
            showSuccessMessage("زبان جدید با موفقیت افزوده شد!")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_=>{
            loading.hide()
            handleCloseDialog()
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={selectedLanguage >= 0 ? "جزئیات زبان" : "افزودن زبان"}
                hasActionButton
                actionButtonTitle={selectedLanguage >= 0 ? "بروزرسانی" : "افزودن"}
                actionButtonOnclick={doAction}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
            >
                <RaikoSimpleInputOutlined
                    labelText={"نام"}
                    setValue={setName}
                    value={name}
                    required
                />
                <RaikoSimpleInputOutlined
                    labelText={"کد زبان"}
                    setValue={setLocale}
                    value={locale}
                    required
                />
                <RaikoCustomSelect
                    items={[
                        raikoCustomSelectItemGenerator("RTL", languageDirectionTypes.RTL),
                        raikoCustomSelectItemGenerator("LTR", languageDirectionTypes.LTR),

                    ]}
                    labelText={"جهت نوشتن"}
                    setValue={setDirection}
                    value={direction}
                />

                <RaikoCustomSelect
                    items={[
                        raikoCustomSelectItemGenerator("JALALI", languageCalenderTypes.JALALI),
                        raikoCustomSelectItemGenerator("GHAMARI", languageCalenderTypes.GHAMARI),
                        raikoCustomSelectItemGenerator("MILADI", languageCalenderTypes.MILADI),
                    ]}
                    labelText={"تقویم"}
                    setValue={setCalendarType}
                    value={calendarType}
                />
                <RaikoToggleOutlined
                    labelText={"وضعیت"}
                    setChecked={setEnabled}
                    checked={enabled}
                />
                <RaikoToggleOutlined
                    labelText={"پیشفرض"}
                    setChecked={setIsDefault}
                    checked={isDefault}
                />

            </RaikoSectionContainer>
        </RaikoBaseDialogContentContainer>
    )
}

const languageDirectionTypes = {
    RTL: "راست به چپ",
    LTR: "چپ به راست"
}

const languageCalenderTypes = {
    JALALI: "جلالی",
    GHAMARI: "قمری",
    MILADI: "میلادی",
}